import { useApiClient } from '../hooks/useApiClient';
import { useAuth } from '../hooks/useAuth/useAuth';
import { useNavigate } from 'react-router-dom';

export interface BannerItem {
  descricao: string;
  valor: string;
}

export const useBackEndRequests = () => {
  const httpCall = useApiClient();
  const httpCallAutenticado = useApiClient();
  const auth = useAuth();
  const navigate = useNavigate();

  httpCallAutenticado.interceptors.request.use((config) => {
    const token = auth.token;

    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    } else if (!auth.isAuthenticated) {
      navigate('/logout');
    }
    return config;
  });

  const getIsDistribuidorAutorizado = async () => {
    const resposta = await httpCallAutenticado.get<boolean>(
      `/pgrm/api/autorizacao/distribuicao`,
    );

    return resposta.data;
  };

  const getDadosBanner = async () => {
    const resposta = await httpCall.get<BannerItem[]>(
      `/pgrm/api/public/dashboard/banner`,
    );

    return resposta.data;
  };

  return {
    getIsDistribuidorAutorizado,
    getDadosBanner,
  };
};
